import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { loadAnalytics } from "@/lib/analytics";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("umbo-cookie-consent");
    if (!consent) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem("umbo-cookie-consent", value);
    if (value === "accepted") loadAnalytics(); // active la mesure d'audience après accord
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 24, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-3 inset-x-3 sm:bottom-5 sm:left-5 sm:right-auto sm:inset-x-auto sm:max-w-[24rem] z-[60]"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Préférences de cookies"
        >
          <div className="relative flex items-start gap-3 bg-white/90 backdrop-blur-md border border-slate-200/80 rounded-2xl shadow-[0_16px_48px_-16px_rgba(7,27,58,0.35)] px-4 py-3.5">
            <button
              onClick={() => decide("refused")}
              className="absolute top-2.5 right-2.5 w-6 h-6 grid place-items-center rounded-full text-slate-400 hover:text-navy hover:bg-slate-100 transition-colors"
              aria-label="Fermer et refuser"
            >
              <X className="w-3.5 h-3.5" />
            </button>

            <div className="mt-0.5 shrink-0 w-8 h-8 rounded-full bg-amber-50 border border-amber-100 grid place-items-center">
              <Cookie className="w-4 h-4 text-amber-600" />
            </div>

            <div className="min-w-0 pr-4">
              <p className="text-[13px] text-slate-600 leading-snug">
                Cookies nécessaires, et mesure d'audience avec votre accord.{" "}
                <Link
                  to="/politique-de-confidentialite"
                  className="text-navy font-medium underline underline-offset-2 whitespace-nowrap"
                >
                  En savoir plus
                </Link>
              </p>
              <div className="mt-3 flex items-center gap-2">
                <button
                  onClick={() => decide("accepted")}
                  className="bg-navy text-white text-xs font-medium rounded-full px-4 py-2 hover:bg-navy-light transition-colors"
                  data-testid="cookie-accept"
                >
                  Accepter
                </button>
                <button
                  onClick={() => decide("refused")}
                  className="text-slate-500 text-xs font-medium rounded-full px-4 py-2 hover:text-navy hover:bg-slate-100 transition-colors"
                  data-testid="cookie-refuse"
                >
                  Refuser
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
